import { defineNuxtPlugin } from 'nuxt/app'
import { LocaleCode, normalizeLocaleParam } from '@packages/i18n'
import { resolveCountryCookieValue, useAppStore } from '../stores/app'
import { COUNTRY_CODE_COOKIE_NAME, resolveCountryCodeFromCookieValue } from '../utils/countryContext'

export default defineNuxtPlugin({
  name: 'app-request-context',
  dependsOn: ['pinia', 'i18n:plugin:route-locale-detect'],
  setup(nuxtApp) {
    const appStore = useAppStore(nuxtApp.$pinia)
    const countryCodeCookie = import.meta.client ? useAppCookie(COUNTRY_CODE_COOKIE_NAME) : null

    const getCountryCodeCookieValue = () => {
      if (import.meta.server) {
        // Nitro middleware 先从 Cookie 解析并写入请求头，Store 与 SWR cache key 共用同一请求级结果。
        return nuxtApp.ssrContext?.event.node.req.headers['country-code']
      }

      return countryCodeCookie?.value
    }

    /** 将 I18n 和国家 Cookie 解析成唯一的应用请求上下文。 */
    const syncRequestContext = (localeValue: unknown = nuxtApp.$i18n.locale.value) => {
      const languageCode = normalizeLocaleParam(localeValue) ?? LocaleCode.En
      const countryCode = resolveCountryCodeFromCookieValue(getCountryCodeCookieValue())

      if (import.meta.client && countryCodeCookie?.value) {
        countryCodeCookie.value = resolveCountryCookieValue(countryCode)
      }

      appStore.setRequestContext({ languageCode, countryCode })
    }

    syncRequestContext()
    nuxtApp.hook('i18n:localeSwitched', ({ newLocale }) => syncRequestContext(newLocale))
  },
})
